import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  language$ = new ReplaySubject<LangChangeEvent>(1);
  langs = ['en-us', 'zh-tw'];

  constructor(private translateService: TranslateService) { }

  setInitState(initLang: string): Observable<any> {
    this.translateService.addLangs(this.langs);

    let lang = '';
    if (this.langs.includes(initLang)) {
      lang = initLang;
    } else {
      const browserLang = (this.translateService.getBrowserLang().includes('zh')) ? 'zh-tw' : 'en-us';
      lang = browserLang;
    }

    return this.setLang(lang);
  }

  setLang(lang: string): Observable<any> {
    // this.translateService.onLangChange.pipe(take(1)).subscribe(result => {
    //   this.language$.next(result);
    // });
    return this.translateService.use(lang);
  }

  getLang(): string {
    return this.translateService.currentLang;
  }

  isSupportLang(lang: string): boolean {
    return this.langs.includes(lang);
  }

  get translate(): TranslateService {
    return this.translateService;
  }
}
